import { Link } from "react-router-dom";
import { Logo, SlashMark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";

export const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="h-9 w-9 grid place-items-center rounded-full border border-border text-foreground/70 hover:text-foreground transition-colors"
      aria-label="Toggle theme"
    >
      <Sun size={16} className="hidden dark:block" />
      <Moon size={16} className="dark:hidden" />
    </button>
  );
};

export const MarketingNav = () => {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 glass">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-foreground/70">
          <Link to="/discover" className="hover:text-foreground transition-colors" data-testid="nav-discover">Discover</Link>
          <Link to="/templates" className="hover:text-foreground transition-colors" data-testid="nav-templates">Templates</Link>
          <Link to="/pricing" className="hover:text-foreground transition-colors" data-testid="nav-pricing">Pricing</Link>
        </div>
        <div className="flex items-center gap-3">
          <ThemeToggle />
          {user ? (
            <Link to="/dashboard"><Button data-testid="nav-dashboard" className="rounded-full">Dashboard</Button></Link>
          ) : (
            <>
              <Link to="/login" className="hidden sm:block text-sm font-medium text-foreground/70 hover:text-foreground transition-colors" data-testid="nav-login">Log in</Link>
              <Link to="/register"><Button data-testid="nav-signup" className="rounded-full">Get started</Button></Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

export const Footer = () => (
  <footer className="border-t border-border bg-background">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Logo />
          <p className="mt-4 text-sm text-muted-foreground max-w-xs">Every story has a timeline. Create beautiful timelines. Publish them anywhere.</p>
        </div>
        <FooterCol title="Product" links={[["Discover","/discover"],["Templates","/templates"],["Pricing","/pricing"]]} />
        <FooterCol title="Create" links={[["Sign up","/register"],["Log in","/login"]]} />
        <FooterCol title="Company" links={[["Mahakali Studios","/"],["Explore","/discover"]]} />
      </div>
      <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <div className="flex items-center gap-2"><SlashMark size={14} color="hsl(var(--primary))" /> © {new Date().getFullYear()} Mahakali Studios</div>
        <div>Made with Timeline</div>
      </div>
    </div>
  </footer>
);

const FooterCol = ({ title, links }) => (
  <div>
    <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">{title}</div>
    <ul className="space-y-2.5 text-sm">
      {links.map(([label, to]) => (
        <li key={label}><Link to={to} className="text-foreground/70 hover:text-foreground transition-colors">{label}</Link></li>
      ))}
    </ul>
  </div>
);
